import axios from 'axios';
import { store } from '../store';

export const getAgencies = () => {
  const { token } = store.getState().auth;
  return new Promise((resolve, reject) => {
    axios({
      url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/agency/`,
      headers: { Authorization: `Token ${token}` },
    }).then(({ data }) => {
      store.dispatch({ type: 'LOAD_AGENCIES', payload: data });
      resolve(data);
    }).catch((err) => {
      store.dispatch({ type: 'ADD_AGENCY_ERROR' });
      reject(err);
    });
  });
};

export const createAgency = (agency) => {
  const { token } = store.getState().auth;

  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/agency/`,
      headers: { Authorization: `Token ${token}` },
      data: {
        name: agency.name,
        // address: agency.address,
        // zipcode: agency.zipcode || '',
        // state: agency.state || '',
        contact_name: agency.contact_name,
        contact_phone: agency.contact_phone,
        contact_email: agency.contact_email,
        description: agency.description,
      },
    })
      .then(({ data }) => {
        resolve(data);
      })
      .then(getAgencies)
      .then(() => store.dispatch({ type: 'ADD_AGENCY_CLEAR_SAVE' }))
      .then(() => store.dispatch({ type: 'TOGGLE_CONTACT_INPUT', payload: false }))
      .catch((err) => {
        store.dispatch({ type: 'ADD_AGENCY_ERROR' });
        reject(err);
      });
  });
};

export const updateAgency = (id, agencyDetails) => {
  const { token } = store.getState().auth;

  return new Promise((resolve, reject) => {
    const filteredData = Object.keys(agencyDetails)
      .filter((detail) => detail !== 'id')
      .reduce((obj, key) => ({
        ...obj,
        [key]: agencyDetails[key],
      }), {});

    axios({
      method: 'put',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/agency/${id}/`,
      headers: { Authorization: `Token ${token}` },
      data: filteredData,
    })
      .then(getAgencies)
      .then(() => store.dispatch({ type: 'ADD_AGENCY_CLEAR_SAVE' }))
      .then(resolve())
      .catch((err) => {
        store.dispatch({ type: 'ADD_AGENCY_ERROR' });
        reject(err);
      });
  });
};
